import React from "react";
import { useAppSelector } from "../../Redux/app/hooks";
import { formatNumber,removeCommaFromString } from "../../helpers/helper";
function BondSOrderConfirmationDetail({ confirm, bid_value, principal_amount,userType, selectedPortfolios,allocate_portfolio,timer_request_rfq }: any) {
  const form = useAppSelector((state) => state.orderSection.rfq_form_data);
  const default_security_set: any = useAppSelector((state) => state.dashBoard.default_security_set);
  const internalPrice = form.direction.toLowerCase() === "sell" && form.rfq_request_id && timer_request_rfq ? Number(timer_request_rfq.bid_price).toFixed(3) : Number(form.limit_price).toFixed(3);
  const totalEstMarkup = selectedPortfolios.reduce((sum: any, item: any) => sum + item.est_markup, 0);

  return (
      <div className="order-confirmation-table">
        <table>
          <thead>
            <tr>
              <th>Description</th>
              <th>Transaction</th>
              <th>Type</th>
              <th>Duration</th>
              <th>Price</th>
              <th>Quantity</th>
              {userType === "internal" && <th>Est. Markup</th>}
              <th>Est. Total</th>
            </tr>
          </thead>
          <tbody>
            <tr className={`${form.direction.toLowerCase() === "buy" ? "buy" : "sell"}-row`}>
              <td>
                <span>{default_security_set.tabName}</span>
                <div className="tooltiptext">
                  <p>{default_security_set.tabName}</p>
                </div>
              </td>
              <td>{form.direction.toUpperCase()}</td>
              <td>{form.type.toUpperCase()}</td>
              <td>
                <span>{confirm.time.replace(/_/g, " ")}</span>
              </td>
              <td>
                <>
                  {bid_value === 0 && form.type.toLowerCase() === "market" && form.direction.toLowerCase() === "sell" ? (
                    <b>N/A</b>
                  ) : (
                    <>{form.direction.toLowerCase() === "sell" && <b>{internalPrice}</b>}</>
                  )}
                </>
              </td>
              <td>
                <b>{formatNumber(form.quantity)}</b>
              </td>
              {userType === "internal" && (
                <td>
                  <b>0</b>
                </td>
              )}
              <td>
                {bid_value === 0 && form.type.toLowerCase() === "market" && form.direction.toLowerCase() === "sell" ? (
                  <b>N/A</b>
                ) : (
                  <>
                    {form.direction.toLowerCase() === "sell" && (
                      <>
                      <b>{`${new Intl.NumberFormat().format((Number(removeCommaFromString(form.quantity)) * Number(internalPrice))/100 )} ${default_security_set.currency}`}</b>
                      </>
                    )}
                  </>
                )}
              </td>
            </tr>
            {/* For client information */}
            {userType === "internal" &&
              selectedPortfolios.filter((allocates_input: any) => 
                allocates_input.client_id !== null &&
                Number(allocates_input.client_id) !== 0 && 
                allocates_input.est_markup !== 0 && 
                allocates_input.est_markup !== null &&
                allocates_input.est_markup !== undefined &&
                allocates_input.qty && 
                Number(allocates_input.qty.replace(",", "")) > 0
              ).length > 0 &&
              selectedPortfolios.map(
                (allocates_input: any, index: any) =>
                  allocates_input.client_id !== null &&
                  Number(allocates_input.client_id) !== 0 && 
                  allocates_input.est_markup !== 0 && 
                  allocates_input.est_markup !== null &&
                  allocates_input.est_markup !== undefined &&
                  allocates_input.qty && 
                  Number(allocates_input.qty.replace(",", "")) > 0 && (
                    <tr key={`EMFI-${allocates_input.client_id}`} className={`${form.direction.toLowerCase() === "buy" ? "buy" : "sell"}-row `}>
                      <td className={"td-text-indent"}>
                        {allocate_portfolio.filter((item: any) => item.id === allocates_input.client_id).map((item: any) => item.name)}
                      </td>
                      <td>{form.direction.toUpperCase()}</td>
                      <td>{form.type.toUpperCase()}</td>
                      <td>{confirm.time.replace(/_/g, " ")}</td>
                      <td>
                        {bid_value === 0 && form.type.toLowerCase() === "market" ? (
                          <b>N/A</b>
                        ) : (
                          <>{<b className="width-100">{Number(allocates_input.markup_price).toFixed(3)}</b>}</>
                        )}
                      </td>
                      <td><b>{formatNumber(allocates_input.qty)}</b></td>
                      {userType === "internal" && (
                        <td>
                          <b>{allocates_input.est_markup}</b>
                        </td>
                      )}
                      <td>
                        {form.type.toLowerCase() === "market" ? (
                          <>
                            {bid_value === 0 && form.type.toLowerCase() === "market" &&  false ? (
                              <b>N/A</b>
                            ) : (
                              <b className="width-100">
                                ({formatNumber(allocates_input.inverse_currency_amt_display)}) {default_security_set.currency}
                              </b>
                            )}
                          </>
                        ) : (
                          <>
                            {
                              <b className="width-100">
                                ({formatNumber(allocates_input.inverse_currency_amt_display)}) {default_security_set.currency}
                              </b>
                            }
                          </>
                        )}
                      </td>
                    </tr>
                  )
              )}
          </tbody>
        </table>
        <>
          {bid_value === 0 && form.type.toLowerCase() === "market" && form.direction.toLowerCase() === "sell" ? (
            <></>
          ) : (
            <>
              {form.direction.toLowerCase() === "sell" && (
                <p>
                  At a price of {Number(internalPrice).toFixed(2)} per share, the value of this trade is estimated at{" "}
                  {`${new Intl.NumberFormat().format((Number(removeCommaFromString(form.quantity)) * Number(internalPrice))/100 )} ${default_security_set.currency}`}
                   {totalEstMarkup !== 0 && ` (Total Est. Markup : ${default_security_set.currency} ${totalEstMarkup})`}
                </p>
              )}
            </>
          )}
        </>
      </div>
  );
}

export default BondSOrderConfirmationDetail;
